module.exports = __webpack_public_path__ + "src/assets/games/10/145.jpg";